import React from 'react';
import { Button } from '@/components/shared/button';
import WeightSelection from '../WeightSelection';
import { ArrowRight } from 'lucide-react';

interface AssessmentFormStepProps {
  onNext: () => void;
}

const AssessmentFormStep = ({ onNext }: AssessmentFormStepProps) => {
  return (
    <div className="space-y-8">
      <WeightSelection />
      <div className="flex justify-end mt-8">
        <Button 
          onClick={onNext}
          variant="outline"
          className="text-white bg-[#CA0079] gap-[11px] whitespace-nowrap px-4 sm:px-[31px] py-[10px] sm:py-[13px] rounded-[10px] hover:bg-[#a0005f] transition-colors text-sm sm:text-base"
        >
          Next
          <ArrowRight className="h-4 w-4 ml-2" />
        </Button>
      </div>
    </div>
  );
};

export default AssessmentFormStep;